<template>
    <div class="cultureCycleClear" style="width:97.8%;border:1px solid #e0e0e0;margin-left:14px;">
      <div class="titleForm-container">{{edit?"编辑养殖周期":"查看养殖周期"}}</div>
      <div :class="{'content-form-container':true,'readonly':!edit}">
        <div class="main-container-form">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" >
            <el-form-item label="基地" prop="fishBaseName" >
              <el-select v-model="ruleForm.fishBaseName" disabled placeholder="请选择" style="width:100%;" >
                 <el-option
                  v-for="(item, index) in baseList"
                  :key="index"
                  :label="item.value"
                  :value="item.key">
                 </el-option>
              </el-select>
            </el-form-item>
            <el-row  :gutter="3">
              <el-form-item label="塘口"  prop="fishPondName" required >        
                <el-col :span="18" :md="{span: 17}">
                  <el-form-item >
                    <el-select placeholder="请选择" disabled size="medium" style="width:100%;" v-model="ruleForm.fishPondName">
                      <el-option
                        v-for="(item, index) in fishPondNoBatch"
                        :key="index"
                        :label="item.fishPondName"
                        :value="item.fishPondId">
                      </el-option>
                    </el-select>
                  </el-form-item>  
                </el-col>
                <el-col :span="4" :md="{span: 5}" :offset="0.5" >
                  <el-form-item prop="batch">
                    <el-input disabled  v-model.number="ruleForm.batch" style="width:100%;" size="medium"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2" :offset="0.5">    
                  <span>批</span>
                </el-col>
              </el-form-item>  
            </el-row>
            <el-form-item label="开始时间"  value-format="yyyy-MM-dd" prop="startDate" >
              <el-col>
               <el-date-picker type="date" 
                placeholder="选择日期" 
                disabled 
                  v-model="ruleForm.startDate" 
                  style="width: 100%;" >
                </el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="清塘时间"  prop="clearedDate" >
              <el-col>
                <el-date-picker 
                  type="date" 
                  v-model="ruleForm.clearedDate" 
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期" 
                 
                  style="width:100%;">
                </el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="备注" prop="mark" >
              <el-input v-model="ruleForm.mark"   placeholder="请输入备注" style="width:100%;"></el-input>
            </el-form-item>
             <el-form-item>
              <el-col :span="8" >
                <el-button  class="edit-save-btn" type="primary"   @click="editSubmitForm('ruleForm')" >保存</el-button>
              </el-col>
              <el-col :span="8">
                <el-button class="cancel-btn"  @click="cancelForm('ruleForm')">取消</el-button>
              </el-col>
            </el-form-item>
          </el-form>
          
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import checkPermission from "../../../service/checkPermission.js";
export default {
  name: "cultureCycleClear",
  data() {
    return {
      edit: checkPermission.checkEdit(this.$route),
      id: this.$route.query.id,
      ruleForm: {
        fishBaseName: "",
        fishPondName: "",
        batch: "",
        startDate: "",
        clearedDate: "",
        mark: ""
      },
      baseList: [], //基地列表
      rules: {
        fishBaseName: [
          { required: true, message: "请选择基地", trigger: "change" }
        ],
        fishPondName: [
          { required: true, message: "请选择塘口", trigger: "change" }
        ],
        batch: [
          {
            min: 0,
            max: 9999,
            pattern: /^[0-9]*$/,
            message: "批次格式有误",
            trigger: "blur"
          }
        ],
        startDate: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change"
          }
        ],

        mark: [{ required: false, message: "请输入备注", trigger: "blur" }]
      }
    };
  },
  methods: {
    ...mapActions(modules.cultureCycle, [
      "getHasClearedData", //已清塘数据,
      "editFishBatchData" //编辑-保存
    ]),
    ...mapActions(modules.base, [
      "getBaseList" //基地信息
    ]),
    //已清塘数据
    getHasClearedDatas() {
      this.getHasClearedData(this.id)
        .then(rsp => {
          if (rsp.status === 200) {
            this.ruleForm = rsp.data || [];
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //编辑--保存
    editSubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            id: this.id, //行id
            fishPondName: this.ruleForm.fishPondName,
            batch: this.ruleForm.batch,
            startDate: this.ruleForm.startDate,
            clearedDate: this.ruleForm.clearedDate,
            remark: this.ruleForm.mark
          };
          this.editFishBatchData(obj)
            .then(rsp => {
              if (rsp.status === 200) {
                // this.showDialog = false;
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                history.go(-1);
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      history.go(-1);
    }
  },
  async mounted() {
    this.getHasClearedDatas();
    this.baseList = await this.getBaseList(); //基地信息
  },
  computed: {
    ...mapState(modules.cultureCycle, ["fishPondNoBatch"])
  }
};
</script>

<style lang="" scoped>
    
</style>
